import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const TestimonialList = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  margin-left: -12px;
  margin-right: -12px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: ${({ bottomGap }) => bottomGap};

  ${hideScrollBar}

  > div {
    width: calc(100% - 32px);
    height: fit-content;
    flex-shrink: 0;
    scroll-snap-align: center;
  }

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    overflow: inherit;
    padding: inherit;
    margin: inherit;
    padding-bottom: ${({ bottomGap }) => bottomGap};

    > div {
      width: 100%;
    }
  }
`;

export const IndicatorRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${QUERIES.largeTabletAndUp} {
    display: none;
  }
`;

export const IndicatorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: ${({ bottomGap }) => `-${bottomGap}`};
`;

export const Indicator = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ isCurrent }) =>
    isCurrent ? themeStyle.primaryHighlighted : themeStyle.grey400};
`;
